import * as _ from "lodash";
import * as accounting from "accounting";

export function toFixed(price: IPriceInCurrency): string {
  return accounting.toFixed(price.price, price.currency.decimalPlaces);
}

const validatePrice = (price: IPriceInCurrency) => {
  if (typeof price.price !== "number") {
    throw new Error(`Type error: property 'price' must be a number. ${price.price} is a ${typeof price.price}`);
  }

  if (!price.currency) {
    throw new Error(`The 'currency' property of a price must have a value`);
  }
}

function roundNumber(price: IPriceInCurrency): number {
  return +toFixed(price);
}

/**
 * ¡This function doesn't actually round the number. It's OK!
 */
export function round(price: IPriceInCurrency): IPriceInCurrency {
  return _.extend({}, price, { price: roundNumber(price) });
}

export function add(...prices: IPriceInCurrency[]): IPriceInCurrency {

  let total: IPriceInCurrency | null = null;

  for (const price of prices) {
    validatePrice(price);

    if (total) {
      if (price.currency.id !== total.currency.id) {
        throw new Error("can only add prices of the same currency");
      }

      total = round(_.assign({}, total, { price: total.price + price.price }));
    }
    else {
      total = price;
    }
  }
  return total as IPriceInCurrency;
}

export function subtract(x: IPriceInCurrency, y: IPriceInCurrency): IPriceInCurrency {
  if (x.currency.id !== y.currency.id) {
    throw new Error("can only subtract prices of the same currency");
  }

  validatePrice(x);
  validatePrice(y);

  return round(_.assign({}, x, { price: x.price - y.price }));
}

export function multiply(price: IPriceInCurrency, multiplier: number): IPriceInCurrency {
  validatePrice(price);
  return round(_.assign({}, price, { price: price.price * multiplier }));
}

export function equals(x: IPriceInCurrency, y: IPriceInCurrency): boolean {
  if (x.currency.id !== y.currency.id) {
    throw new Error("can only compare prices of the same currency");
  }

  return toFixed(x) === toFixed(y);
}

export function greaterThan(x: IPriceInCurrency, y: IPriceInCurrency): boolean {
  if (x.currency.id !== y.currency.id) {
    throw new Error("can only compare prices of the same currency");
  }

  return roundNumber(x) > roundNumber(y);
}

export function isZero(x: IPriceInCurrency): boolean {
  return toFixed(x) === toFixed({ price: 0, currency: x.currency });
}

export function formatForCustomer(price: IPriceInCurrency): string {

  return accounting.formatMoney(price.price, {
    symbol: price.currency.symbol,
    precision: price.currency.decimalPlaces
  });
}

export function formatForLtoOrAdmin(price: IPriceInCurrency): string {
  return accounting.formatMoney(price.price, {
    symbol: price.currency.code,
    format: "%v %s",
    precision: price.currency.decimalPlaces
  });
}
